// extracted by mini-css-extract-plugin
module.exports = {"header":"index_header__3dfWx","neon1":"index_neon1__CIV8u"};